import PropTypes from 'prop-types';
import React from "react";
import ObjectSearchInput from 'components/functional/inputs/ObjectSearchInput'
import renderName from 'utils/renderName';
import { formatPhone } from 'utils/text'
import _contacts from '_functions/contacts';
import * as _ from 'underscore';

class ContactSearchInput extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            filter: null,
            showResults: false,
            selected: {},
            dataToShow: [],
        }
       this.queryContactsThrottled = _.throttle(this.queryContacts, 750)
    }


    onSelect = (selected) => {

        this.setState({selected, filter: '', showResults: false})
        this.props.onSelect(selected)

    }

    queryContacts = async (value) => {

        const contacts = await _contacts.search({
            search: value,
            limit: 50,
        })

        if(contacts.success) {
            this.setState({dataToShow: contacts.data, showResults: this.state.filter ? true : false})
        }

    }

    onChange = async (value) => {

        this.setState({filter: value})

        if(value) {
            this.queryContactsThrottled(value)
        } else {
            this.setState({filter: null, showResults: false})
        }

    }


    componentDidMount = () => {
        const { value } = this.props
        this.setState({ selected: value ? value : {} })
    }

    render() {

        const { dataToShow, selected } = this.state
        const { titleFormatter } = this.props

        return (
            <ObjectSearchInput 
                data={dataToShow}
                onChange={this.onChange}
                onSelect={this.onSelect}
                placeholderFormatter={selected ? selected.name : 'Type To Search'}
                titleFormatter={
                    titleFormatter ? titleFormatter(selected) : 
                        selected ? <span>Selected Contact: <b className="text-success text-capitalize">{renderName(selected)}</b></span> : 
                        'Select Contact'
                }
                resultsFormatter={(result) => (
                    selected._id !== result._id ? (
                        <li key={result._id} onClick={() => this.onSelect(result)}>
                            <p className="text-sm mb-0 text-capitalize">
                                <i className="fas fa-user mr-2" />
                                {renderName(result) === 'Not Found' ? 'Name Not Found' : renderName(result)}
                            </p>
                            {result.phone ? 
                                <p className="text-sm mb-0 text-muted">
                                    <i className="fas fa-phone mr-2" />
                                    {formatPhone(result.phone)}
                                </p> 
                            : null}
                            {result.email ? 
                                <p className="text-sm mb-0 text-muted">
                                    <i className="fas fa-envelope mr-2" />
                                    {result.email} 
                                </p> 
                            : null }
                        </li>
                    ) : null
                )}
            />
        );
    }
}

ContactSearchInput.propTypes = {
    onSelect        : PropTypes.func.isRequired,
    titleFormatter  : PropTypes.func,
    wrapperStyles   : PropTypes.object,
    formGroupStyles : PropTypes.object,
    value           : PropTypes.object,
    hideTitle       : PropTypes.bool,
    title           : PropTypes.string,
}

export default ContactSearchInput
